export default "__VITE_ASSET__BkVJBZsC__"